module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    attrs: {
      "textarea": true
    },
    model: {
      value: (_vm.question.content),
      callback: function($$v) {
        _vm.question.content = $$v
      },
      expression: "question.content"
    }
  }), _vm._v(" "), _c('b-input-group', {
    staticClass: "mt-2",
    attrs: {
      "left": "Antwort"
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.question.answer),
      callback: function($$v) {
        _vm.question.answer = $$v
      },
      expression: "question.answer"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.question.alternatives), function(alternative, altKey) {
    return _c('div', {
      key: altKey,
      staticClass: "mt-2 ml-5"
    }, [_c('b-button', {
      staticClass: "pull-right",
      attrs: {
        "size": 'sm',
        "variant": 'link'
      },
      on: {
        "click": function($event) {
          _vm.removeAlternative(_vm.questionKey, altKey)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times text-muted"
    })]), _vm._v(" "), _c('b-input-group', {
      staticClass: "mb-1",
      attrs: {
        "left": (altKey + 1) + '. Alternative',
        "size": 'sm'
      }
    }, [_c('b-form-input', {
      model: {
        value: (alternative.answer),
        callback: function($$v) {
          alternative.answer = $$v
        },
        expression: "alternative.answer"
      }
    })], 1), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "textarea": true,
        "placeholder": "Message.."
      },
      model: {
        value: (alternative.message),
        callback: function($$v) {
          alternative.message = $$v
        },
        expression: "alternative.message"
      }
    })], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": 'link',
      "size": 'sm'
    },
    on: {
      "click": function($event) {
        _vm.addAlternative()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v(" Alternative")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e4d27d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/questions/one/One.Edit.vue
// module id = 711
// module chunks = 1